module.exports = __webpack_public_path__ + "img/login-unionyamistad.264a859b.svg";